import { CompatibleProductId } from '@atlassian/mpac-types';
import BambooLeftDesktop from '../assets/productHero/Bamboo/Bamboo_left.svg';
import BambooMobile from '../assets/productHero/Bamboo/Bamboo_mobile.svg';
import BambooRightDesktop from '../assets/productHero/Bamboo/Bamboo_right.svg';
import BambooTablet from '../assets/productHero/Bamboo/Bamboo_tablet.svg';
import BitbucketLeftDesktop from '../assets/productHero/Bitbucket/Bitbucket_left.svg';
import BitbucketMobile from '../assets/productHero/Bitbucket/Bitbucket_mobile.svg';
import BitbucketRightDesktop from '../assets/productHero/Bitbucket/Bitbucket_right.svg';
import BitbucketTablet from '../assets/productHero/Bitbucket/Bitbucket_tablet.svg';
import CompassLeftDesktop from '../assets/productHero/Compass/Compass_left.svg';
import CompassMobile from '../assets/productHero/Compass/Compass_mobile.svg';
import CompassRightDesktop from '../assets/productHero/Compass/Compass_right.svg';
import CompassTablet from '../assets/productHero/Compass/Compass_tablet.svg';
import ConfluenceLeftDesktop from '../assets/productHero/Confluence/Confluence_left.svg';
import ConfluenceMobile from '../assets/productHero/Confluence/Confluence_mobile.svg';
import ConfluenceRightDesktop from '../assets/productHero/Confluence/Confluence_right.svg';
import ConfluenceTablet from '../assets/productHero/Confluence/Confluence_tablet.svg';
import CrowdLeftDesktop from '../assets/productHero/Crowd/Crowd_left.svg';
import CrowdMobile from '../assets/productHero/Crowd/Crowd_mobile.svg';
import CrowdRightDesktop from '../assets/productHero/Crowd/Crowd_right.svg';
import CrowdTablet from '../assets/productHero/Crowd/Crowd_tablet.svg';
import CrucibleLeftDesktop from '../assets/productHero/Crucible/Crucible_left.svg';
import CrucibleMobile from '../assets/productHero/Crucible/Crucible_mobile.svg';
import CrucibleRightDesktop from '../assets/productHero/Crucible/Crucible_right.svg';
import CrucibleTablet from '../assets/productHero/Crucible/Crucible_tablet.svg';
import FisheyeLeftDesktop from '../assets/productHero/Fisheye/Fisheye_left.svg';
import FisheyeMobile from '../assets/productHero/Fisheye/Fisheye_mobile.svg';
import FisheyeRightDesktop from '../assets/productHero/Fisheye/Fisheye_right.svg';
import FisheyeTablet from '../assets/productHero/Fisheye/Fisheye_tablet.svg';
import JiraLeftDesktop from '../assets/productHero/Jira/Jira_left.svg';
import JiraMobile from '../assets/productHero/Jira/Jira_mobile.svg';
import JiraRightDesktop from '../assets/productHero/Jira/Jira_right.svg';
import JiraTablet from '../assets/productHero/Jira/Jira_tablet.svg';
import JSMLeftDesktop from '../assets/productHero/JSM/JSM_left.svg';
import JSMMobile from '../assets/productHero/JSM/JSM_mobile.svg';
import JSMRightDesktop from '../assets/productHero/JSM/JSM_right.svg';
import JSMTablet from '../assets/productHero/JSM/JSM_tablet.svg';
export const productInfoMap = {
  [CompatibleProductId.Jira]: {
    banner: {
      breadcrumbTitle: 'Jira',
      heading: 'Explore apps for Jira',
      description: 'Elevate your experience with customizable apps to fit any use case',
      heroDesktopLeftImage: JiraLeftDesktop,
      heroDesktopRightImage: JiraRightDesktop,
      heroTabletImage: JiraTablet,
      heroMobileImage: JiraMobile
    },
    showEnterpriseAppsSection: true
  },
  [CompatibleProductId.Confluence]: {
    banner: {
      breadcrumbTitle: 'Confluence',
      heading: 'Explore apps for Confluence',
      description: 'Enhance content collaboration with apps to customize for your team’s needs',
      heroDesktopLeftImage: ConfluenceLeftDesktop,
      heroDesktopRightImage: ConfluenceRightDesktop,
      heroTabletImage: ConfluenceTablet,
      heroMobileImage: ConfluenceMobile
    },
    showEnterpriseAppsSection: true
  },
  [CompatibleProductId.JiraServiceManagement]: {
    banner: {
      breadcrumbTitle: 'Jira Service Management',
      heading: 'Explore apps for Jira Service Management',
      description: 'Provide exceptional service with best suited apps to boost your business',
      heroDesktopLeftImage: JSMLeftDesktop,
      heroDesktopRightImage: JSMRightDesktop,
      heroTabletImage: JSMTablet,
      heroMobileImage: JSMMobile
    },
    showEnterpriseAppsSection: true
  },
  [CompatibleProductId.Fisheye]: {
    banner: {
      breadcrumbTitle: 'Fisheye',
      heading: 'Explore apps for Fisheye',
      description: 'Leverage apps to effectively illustrate and expedite your coding modifications',
      heroDesktopLeftImage: FisheyeLeftDesktop,
      heroDesktopRightImage: FisheyeRightDesktop,
      heroTabletImage: FisheyeTablet,
      heroMobileImage: FisheyeMobile
    }
  },
  [CompatibleProductId.Crucible]: {
    banner: {
      breadcrumbTitle: 'Crucible',
      heading: 'Explore apps for Crucible',
      description: 'Find apps that boost collaborative code assessment and efficient knowledge exchange',
      heroDesktopLeftImage: CrucibleLeftDesktop,
      heroDesktopRightImage: CrucibleRightDesktop,
      heroTabletImage: CrucibleTablet,
      heroMobileImage: CrucibleMobile
    }
  },
  [CompatibleProductId.Bitbucket]: {
    banner: {
      breadcrumbTitle: 'Bitbucket',
      heading: 'Explore apps for Bitbucket',
      description: 'Expand capabilities and streamline your code collaboration methods with apps',
      heroDesktopLeftImage: BitbucketLeftDesktop,
      heroDesktopRightImage: BitbucketRightDesktop,
      heroTabletImage: BitbucketTablet,
      heroMobileImage: BitbucketMobile
    }
  },
  [CompatibleProductId.Bamboo]: {
    banner: {
      breadcrumbTitle: 'Bamboo',
      heading: 'Explore apps for Bamboo',
      description: 'Unleash the power of agile development with apps, from code to deployment',
      heroDesktopLeftImage: BambooLeftDesktop,
      heroDesktopRightImage: BambooRightDesktop,
      heroTabletImage: BambooTablet,
      heroMobileImage: BambooMobile
    }
  },
  [CompatibleProductId.Crowd]: {
    banner: {
      breadcrumbTitle: 'Crowd',
      heading: 'Explore apps for Crowd',
      description: 'Optimize identity management with dynamic user control and authentication apps',
      heroDesktopLeftImage: CrowdLeftDesktop,
      heroDesktopRightImage: CrowdRightDesktop,
      heroTabletImage: CrowdTablet,
      heroMobileImage: CrowdMobile
    }
  },
  [CompatibleProductId.COMPASS]: {
    banner: {
      breadcrumbTitle: 'Compass',
      heading: 'Explore apps for Compass',
      description: 'Customize and build new capabilities to create an efficient developer experience',
      heroDesktopLeftImage: CompassLeftDesktop,
      heroDesktopRightImage: CompassRightDesktop,
      heroTabletImage: CompassTablet,
      heroMobileImage: CompassMobile
    }
  }
};